<template>
	<div class="page_content explore_entity_inside career related_careers" aria-label="Related Careers">

		<div class="row page-heading">
			<div class="col-xl-7 col-lg-7 col-md-6 col-sm-6 col-7 input module_heading">
				<div class="module_icon ico-career"></div>
				<template v-if="career && career.name">
    			<career-title class="title_container" :career="career"></career-title>
    		</template>
			</div>

      <div class="col-xl-5 col-lg-5 col-md-6 col-sm-6 col-5 px-0">
    		<!--
    		<b-dropdown :animation="animation" variant="link" no-caret class="create-section-menu">
      		<template slot="button-content">
        		<span class="icon-menu3x3"></span>
      		</template>
    		</b-dropdown>
    		-->
    		<div class="btn_container" v-if="showBackToResultButton">
					<b-btn @click.stop.prevent="returnToClicked" :aria-label="deCamelCase()">
		       	<span class="btn_ic ic-back"></span>
		       	<span class="btn_txt"> {{ deCamelCase() }} </span>
	      	</b-btn>
				</div>
    	</div>
		</div>


  		<div class="page_content_container">

  			<career-navigation :active="'related'" :code="code" :cipCode="cipCode" :returnTo="returnTo"></career-navigation>

  			<div class="row pg_content list_view">

  				<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content_mid_panel">

						<div class="tabs">
							<div class="card-header">
								<ul class="nav nav-tabs card-header-tabs">

									<template>
										<li class="nav-item">
											<b-link  class="nav-link" :class="isSimilarCareersActive" id="tab_SimilarCareers" @click="showTabContent('tab_SimilarCareers', 'tabPan_SimilarCareers')" :disabled="similarCareers.length === 0">
												<span id="similarCareersTour" class="btn_txt">Similar</span>
											</b-link>
										</li>
										<li class="nav-item">
											<b-link  class="nav-link" :class="isAdvancementCareersActive" id="tab_AdvancementCareers" @click="showTabContent('tab_AdvancementCareers', 'tabPan_AdvancementCareers')" :disabled="advancementCareers.length === 0">
												<span id="advancementCareersTour" class="btn_txt">Advancement</span>
											</b-link>
										</li>
										<li class="nav-item">
											<b-link  class="nav-link" :class="isFeederCareersActive" id="tab_FeederCareers" @click="showTabContent('tab_FeederCareers', 'tabPan_FeederCareers')" :disabled="feederCareers.length === 0">
												<span id="feederCareersTour" class="btn_txt">Feeder</span>
											</b-link>
										</li>
									</template>

								</ul> <!-- .card-header-tabs -->
							</div> <!-- .card-header -->

						</div> <!-- .tabs -->

						<div class="tab_content_section">
							<div class="tab_content_container">

								<div class="tab_content" :class="isSimilarCareersActive" id="tabPan_SimilarCareers">

									<template v-if="similarCareers && similarCareers.length > 0">
										<div class="row result_row" v-for="(rC, index) in similarCareers">

											<div class="col-xl-2 col-lg-2 col-md-2 col-sm-4 thumbnail_section" @click.stop.prevent="goToCareerDetail(rC)">
												<div class="thumbnail_container ace_sec">
													<div class="thumbnail_img" v-if="rC.thumbnailURI">
														<img v-bind:src="rC.thumbnailURI" alt="Img" onerror="this.onerror=null;this.src='https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/career-default.svg';">
													</div>
													<div class="thumbnail" v-else>
														<div class="txt_bx" :id="setTitleBoxWidth(rC.name, 'thumb_' + index)" v-html="setTitleInitials(rC.name)"></div>
													</div>
												</div>
											</div>


											<div class="col-xl-6 col-lg-6 col-md-5 col-sm-8 entity_detail_section" :class="updateTitleHeight(index)">
												<div class="row">
													<div class="col-12 title_row">
														<!--
														<span class="icon icon-career"></span>
														-->
														<span class="title ace_sec_txt" :id="'entityName1_' + index" @click.stop="goToCareerDetail(rC)" :aria-label="rC.name">{{rC.name}}</span>

														<!--
														<span
															v-if="isBookmarked(rC)"
															@click.stop.prevent="deleteCareerBookmark(rC)"
															class="ic_bm_container bookmarked ace_sec_txt"
															title="remove this career from bookmark">
															<span class="icon-bookmark"></span>
														</span>
														<span
															v-else-if="!isBookmarked(rC)"
															@click.stop.prevent="bookmarkCareer(rC)"
															class="ic_bm_container ace_sec_txt"
															title="bookmark this career">
															<span class="icon-bookmark"></span>
														</span>
														-->

														<b-popover :target="'entityName1_' + index" triggers="hover" placement="top" class="title_popup" :container="'entityNameContainer1_' + index">
															<div class="title_container">
																{{rC.name}}
															</div>
														</b-popover>
														<div :id="'entityNameContainer1_' + index" class="title_container_popup"></div>

													</div>

													<div class="col-12 description ace_sec_txt" :id="'entityDesc_' + index" v-if="rC.description">
														 <span class="desc_txt">{{ rC.description }}</span>
													</div>
													<div class="col-12 no_description empty_pattern ace_sec_txt" aria-label="No description added for this career" v-else>
														 No description added for this career
													</div>

												</div>
											</div>

											<div class="col-xl-4 col-lg-4 col-md-5 col-sm-12 other_info">
												<div class="row">
													<div class="col-xl-12 col-lg-12 col-md-12 col-sm-4 list_info_row">
														<div class="info_title">median income</div>
														<div class="info_val ace_sec_txt" v-if="rC.medianEarning" :aria-label="'median income is ' + rC.medianEarning">
															$<span v-html="addCommaInNumber(rC.medianEarning)"></span>
														</div>
														<div v-else class="info_no_val ace_sec_txt" aria-label="median income is not available for this career">
															<div class="no_data_msg2 d-flex justify-content-end">Data Unavailable</div>
														</div>
													</div>

													<div class="col-xl-12 col-lg-12 col-md-12 col-sm-4 list_info_row">
														<div class="info_title">job postings</div>
														<div v-if="rC.currentEmployment" class="info_val ace_sec_txt" :aria-label="'job postings are ' + rC.currentEmployment + ' for this career'">
															<span v-html="addCommaInNumber(rC.currentEmployment)"></span>
														</div>
														<div v-else class="info_no_val ace_sec_txt" aria-label="job postings are not available for this career">
															<div class="no_data_msg2 d-flex justify-content-end">Data Unavailable</div>
														</div>
													</div>

													<div class="col-xl-12 col-lg-12 col-md-12 col-sm-4 list_info_row">
														<div class="info_title">growth rate</div>
														<div v-if="rC.growth" class="info_val ace_sec_txt" :aria-label="'Growth rate is ' + rC.growth + ' for this career'">
															<span>{{(Math.round(rC.growth * 100) / 100).toFixed(1)}} %</span>
														</div>
														<div v-else class="info_no_val ace_sec_txt" aria-label="growth rate is not available for this career">
															<div class="no_data_msg2 d-flex justify-content-end">Data Unavailable</div>
														</div>
													</div>

												</div>
											</div>


										</div>
									</template>

									<template v-if="similarCareers.length === 0">
			        			<div class="row">
					        		<div class="col-12 msg_no_data empty_pattern">
												No related careers for this career
											</div>
										</div>
		        			</template>

								</div> <!-- #tabPan_SimilarCareers -->


								<div class="tab_content"  :class="isAdvancementCareersActive" id="tabPan_AdvancementCareers">

									<template v-if="advancementCareers && advancementCareers.length > 0">
										<div class="row result_row" v-for="(rC, index) in advancementCareers">

											<div class="col-xl-2 col-lg-2 col-md-2 col-sm-4 thumbnail_section" @click.stop.prevent="goToCareerDetail(rC)">
												<div class="thumbnail_container ace_sec">
													<div class="thumbnail_img" v-if="rC.thumbnailURI">
														<img v-bind:src="rC.thumbnailURI" alt="Img" onerror="this.onerror=null;this.src='https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/career-default.svg';">
													</div>
													<div class="thumbnail" v-else>
														<div class="txt_bx" :id="setTitleBoxWidth(rC.name, 'thumb_' + index)" v-html="setTitleInitials(rC.name)"></div>
													</div>
												</div>
											</div>


											<div class="col-xl-6 col-lg-6 col-md-5 col-sm-8 entity_detail_section" :class="updateTitleHeight(index)">
												<div class="row">
													<div class="col-12 title_row">
														<!--
														<span class="icon icon-career"></span>
														-->
														<span class="title ace_sec_txt" :id="'entityName2_' + index" @click.stop="goToCareerDetail(rC)" :aria-label="rC.name">{{rC.name}}</span>

														<!--
														<span
															v-if="isBookmarked(rC)"
															@click.stop.prevent="deleteCareerBookmark(rC)"
															class="ic_bm_container bookmarked ace_sec_txt"
															title="remove this career from bookmark">
															<span class="icon-bookmark"></span>
														</span>
														<span
															v-else-if="!isBookmarked(rC)"
															@click.stop.prevent="bookmarkCareer(rC)"
															class="ic_bm_container ace_sec_txt"
															title="bookmark this career">
															<span class="icon-bookmark"></span>
														</span>
														-->

														<b-popover :target="'entityName2_' + index" triggers="hover" placement="top" class="title_popup" :container="'entityNameContainer2_' + index">
															<div class="title_container">
																{{rC.name}}
															</div>
														</b-popover>
														<div :id="'entityNameContainer2_' + index" class="title_container_popup"></div>

													</div>

													<div class="col-12 description ace_sec_txt" :id="'entityDesc_' + index" v-if="rC.description">
														 <span class="desc_txt">{{ rC.description }}</span>
													</div>
													<div class="col-12 no_description empty_pattern ace_sec_txt" aria-label="No description added for this career" v-else>
														 No description added for this career
													</div>

												</div>
											</div>

											<div class="col-xl-4 col-lg-4 col-md-5 col-sm-12 other_info">
												<div class="row">
													<div class="col-xl-12 col-lg-12 col-md-12 col-sm-4 list_info_row">
														<div class="info_title">median income</div>
														<div class="info_val ace_sec_txt" v-if="rC.medianEarning" :aria-label="'median income is ' + rC.medianEarning">
															$<span v-html="addCommaInNumber(rC.medianEarning)"></span>
														</div>
														<div v-else class="info_no_val ace_sec_txt" aria-label="median income is not available for this career">
															<div class="no_data_msg2 d-flex justify-content-end">Data Unavailable</div>
														</div>
													</div>

													<div class="col-xl-12 col-lg-12 col-md-12 col-sm-4 list_info_row">
														<div class="info_title">job postings</div>
														<div v-if="rC.currentEmployment" class="info_val ace_sec_txt" :aria-label="'job postings are ' + rC.currentEmployment + ' for this career'">
															<span v-html="addCommaInNumber(rC.currentEmployment)"></span>
														</div>
														<div v-else class="info_no_val ace_sec_txt" aria-label="job postings are not available for this career">
															<div class="no_data_msg2 d-flex justify-content-end">Data Unavailable</div>
														</div>
													</div>

													<div class="col-xl-12 col-lg-12 col-md-12 col-sm-4 list_info_row">
														<div class="info_title">growth rate</div>
														<div v-if="rC.growth" class="info_val ace_sec_txt" :aria-label="'Growth rate is ' + rC.growth + ' for this career'">
															<span>{{(Math.round(rC.growth * 100) / 100).toFixed(1)}} %</span>
														</div>
														<div v-else class="info_no_val ace_sec_txt" aria-label="growth rate is not available for this career">
															<div class="no_data_msg2 d-flex justify-content-end">Data Unavailable</div>
														</div>
													</div>

												</div>
											</div>


										</div>
									</template>


									<template v-if="advancementCareers.length === 0">
			        			<div class="row">
					        		<div class="col-12 msg_no_data empty_pattern">
												No related careers for this career
											</div>
										</div>
		        			</template>


								</div> <!-- #tabPan_AdvancementCareers -->


								<div class="tab_content"  :class="isFeederCareersActive" id="tabPan_FeederCareers">

									<template v-if="feederCareers && feederCareers.length > 0">
										<div class="row result_row" v-for="(rC, index) in feederCareers">

											<div class="col-xl-2 col-lg-2 col-md-2 col-sm-4 thumbnail_section" @click.stop.prevent="goToCareerDetail(rC)">
												<div class="thumbnail_container ace_sec">
													<div class="thumbnail_img" v-if="rC.thumbnailURI">
														<img v-bind:src="rC.thumbnailURI" alt="Img" onerror="this.onerror=null;this.src='https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/career-default.svg';">
													</div>
													<div class="thumbnail" v-else>
														<div class="txt_bx" :id="setTitleBoxWidth(rC.name, 'thumb_' + index)" v-html="setTitleInitials(rC.name)"></div>
													</div>
												</div>
											</div>


											<div class="col-xl-6 col-lg-6 col-md-5 col-sm-8 entity_detail_section" :class="updateTitleHeight(index)">
												<div class="row">
													<div class="col-12 title_row">
														<!--
														<span class="icon icon-career"></span>
														-->
														<span class="title ace_sec_txt" :id="'entityName3_' + index" @click.stop="goToCareerDetail(rC)" :aria-label="rC.name">{{rC.name}}</span>

														<!--
														<span
															v-if="isBookmarked(rC)"
															@click.stop.prevent="deleteCareerBookmark(rC)"
															class="ic_bm_container bookmarked ace_sec_txt"
															title="remove this career from bookmark">
															<span class="icon-bookmark"></span>
														</span>
														<span
															v-else-if="!isBookmarked(rC)"
															@click.stop.prevent="bookmarkCareer(rC)"
															class="ic_bm_container ace_sec_txt"
															title="bookmark this career">
															<span class="icon-bookmark"></span>
														</span>
														-->

														<b-popover :target="'entityName3_' + index" triggers="hover" placement="top" class="title_popup" :container="'entityNameContainer3_' + index">
															<div class="title_container">
																{{rC.name}}
															</div>
														</b-popover>
														<div :id="'entityNameContainer3_' + index" class="title_container_popup"></div>

													</div>

													<div class="col-12 description ace_sec_txt" :id="'entityDesc_' + index" v-if="rC.description">
														 <span class="desc_txt">{{ rC.description }}</span>
													</div>
													<div class="col-12 no_description empty_pattern ace_sec_txt" aria-label="No description added for this career" v-else>
														 No description added for this career
													</div>

												</div>
											</div>

											<div class="col-xl-4 col-lg-4 col-md-5 col-sm-12 other_info">
												<div class="row">
													<div class="col-xl-12 col-lg-12 col-md-12 col-sm-4 list_info_row">
														<div class="info_title">median income</div>
														<div class="info_val ace_sec_txt" v-if="rC.medianEarning" :aria-label="'median income is ' + rC.medianEarning">
															$<span v-html="addCommaInNumber(rC.medianEarning)"></span>
														</div>
														<div v-else class="info_no_val ace_sec_txt" aria-label="median income is not available for this career">
															<div class="no_data_msg2 d-flex justify-content-end">Data Unavailable</div>
														</div>
													</div>

													<div class="col-xl-12 col-lg-12 col-md-12 col-sm-4 list_info_row">
														<div class="info_title">job postings</div>
														<div v-if="rC.currentEmployment" class="info_val ace_sec_txt" :aria-label="'job postings are ' + rC.currentEmployment + ' for this career'">
															<span v-html="addCommaInNumber(rC.currentEmployment)"></span>
														</div>
														<div v-else class="info_no_val ace_sec_txt" aria-label="job postings are not available for this career">
															<div class="no_data_msg2 d-flex justify-content-end">Data Unavailable</div>
														</div>
													</div>

													<div class="col-xl-12 col-lg-12 col-md-12 col-sm-4 list_info_row">
														<div class="info_title">growth rate</div>
														<div v-if="rC.growth" class="info_val ace_sec_txt" :aria-label="'Growth rate is ' + rC.growth + ' for this career'">
															<span>{{(Math.round(rC.growth * 100) / 100).toFixed(1)}} %</span>
														</div>
														<div v-else class="info_no_val ace_sec_txt" aria-label="growth rate is not available for this career">
															<div class="no_data_msg2 d-flex justify-content-end">Data Unavailable</div>
														</div>
													</div>

												</div>
											</div>


										</div>
									</template>


									<template v-if="feederCareers.length === 0">
										<div class="row">
											<div class="col-12 msg_no_data empty_pattern">
												No related careers for this career
											</div>
										</div>
									</template>


								</div> <!-- #tabPan_FeederCareers -->

							</div>
						</div>



        		</div>

  			</div> <!-- .pg_content -->

  		</div> <!-- .page_content_container -->


	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CareerTitle from './CareerTitle'
import CareerNavigation from './CareerNavigation'
import { StorageFactory } from '../../../storageFactory'
export const localStore = StorageFactory(() => localStorage)

export default {
  name: 'relatedCareers',
  props: ['code', 'cipCode', 'returnTo', 'showBackToResultButton'],
  components: {
  	CareerTitle,
    CareerNavigation
  },
  data: () => {
    return {
      career: {},
      relatedCareers: [],
      DEFAULT_RETURN_TO: 'exploreCareerResults',
      EXPLORE_RESULTS: 'exploreCareerResults'
    }
  },

  mounted () {
    this.loadDataForCareerPrograms()
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadLogDashboardActivity',
      'loadCareer',
      'loadRelatedCareers'
    ]),
    async loadDataForCareerPrograms () {
      this.career = await this.loadCareer({ code: this.code, loadDataFromServer: true })
      this.relatedCareers = await this.loadRelatedCareers(this.code)
      this.loadLogDashboardActivity({action: 'viewRelatedCareers', page: 'relatedCareers', link: '', careerSocCode: this.code})
    },
    goToCareerDetail (rC) {
      let routerParams = {
        code: rC.pragyaSoc,
        returnTo: 'relatedCareers',
        showBackToResultButton: true
      }
      let returnRouterParams = {
        code: this.code,
        cipCode: this.cipCode,
        returnTo: this.EXPLORE_RESULTS,
        showBackToResultButton: true
      }
      localStore.setItem('returnCareerIntroParams', JSON.stringify(returnRouterParams))
      return this.$router.push({ name: 'careerDetail', params: routerParams, query: {returnTo: 'relatedCareers'} })
    },
    setTitleInitials (streamTitle) {
      let getTitleInitials = streamTitle.match(/\b(\w)/g)
      return getTitleInitials.join('')
    },
    setThumbnailBgColor (entityId) {
      let getNumricValue = entityId.replace(/[^0-9]/g, '')
      return '#' + getNumricValue.slice((getNumricValue.length - 8), (getNumricValue.length - 2))
    },
    setTitleBoxWidth (entityTitle, entityId) {
      let getTitleInitials = entityTitle.match(/\b(\w)/g)
      if (getTitleInitials.length < 3) {
        $('#' + entityId).addClass('txt_bx_' + getTitleInitials.length)
      }
      return entityId
    },
    addCommaInNumber (numValue) {
      return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    updateTitleHeight (index) {
      let titleContainerHeight = $('#entityName_' + index).height()
      if (titleContainerHeight > 30) {
        $('#entityDesc_' + index).addClass('srt_desc')
      }
    },
    async bookmarkCareer (career) {
      const bookmark = {
        'source': 'explore',
        'entityType': 'career',
        'entityTitle': career.name,
        'entityUuid': career.uuid,
        'userId': career.userId
      }
      const response = await this.loadCreateBookmarks(bookmark)
      const message = (response ? 'Successfully bookmarked \'' : 'Unable to bookmark \'') + career.name + '\''
      const notify = response ? this.notifySuccess : this.notifyFailure
      notify(message)
      await this.loadAllBookmarks() // Refresh Vuex state to mark Career as bookmarked
    },
    async deleteCareerBookmark (career) {
      await this.loadDeleteBookmark(career.bookmark.uuid)
      await this.loadAllBookmarks() // Refresh Vuex state to mark Career as bookmarked
    },
    notifySuccess (text) {
      return this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: text
      })
    },
    notifyFailure (text) {
      return this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: text
      })
    },
    returnToClicked () {
      return this.$router.push({name: this.EXPLORE_RESULTS})
    },
    deCamelCase () {
      if (!this.returnTo) {
        this.returnTo = this.DEFAULT_RETURN_TO
      }
      if ((this.returnTo === this.EXPLORE_RESULTS) || (this.$route.query.returnTo === this.EXPLORE_RESULTS)) {
        return 'return to career results'
      }
      let result = this.returnTo.replace(/([A-Z])/g, ' $1')
      return 'return to ' + result
    },
    showTabContent (tabId, tabPanelId) {
      $('.tab_content').removeClass('active')
      $('#' + tabPanelId).addClass('active')
      $('.tabs .nav-link').removeClass('active')
      $('#' + tabId).addClass('active')
    }
  },

  computed: {
    ...mapState({
    }),
    isSimilarCareersActive () {
      if (this.similarCareers.length > 0) {
        return 'active'
      }
      return ''
    },
    isAdvancementCareersActive () {
      if (this.similarCareers.length === 0 && this.advancementCareers.length > 0) {
        return 'active'
      }
      return ''
    },
    isFeederCareersActive () {
      if (this.similarCareers.length === 0 && this.advancementCareers.length === 0 && this.feederCareers.length > 0) {
        return 'active'
      }
      return ''
    },
    similarCareers () {
      let similarCareers = []
      this.relatedCareers.forEach((item, i) => {
        if (item.relatedCareerType === 'lateralOccupations') {
          similarCareers.push(item)
        }
      })
      return similarCareers
    },
    feederCareers () {
      let feederCareers = []
      this.relatedCareers.forEach((item, i) => {
        if (item.relatedCareerType === 'feederOccupations') {
          feederCareers.push(item)
        }
      })
      return feederCareers
    },
    advancementCareers () {
      let advancementCareers = []
      this.relatedCareers.forEach((item, i) => {
        if (item.relatedCareerType === 'advancementOccupations') {
          advancementCareers.push(item)
        }
      })
      return advancementCareers
    }
  },

  watch: {
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/app/career/components/RelatedCareers.vue